import React from 'react';
import {Field} from 'redux-form';

import {AsyncSelectField} from 'components/Fields';
import {BookingOption, Arrow} from './components';

import zoomIcon from './assets/zoom.svg';

import './styles.css';

export const buildBookingOptions = data => data.results.map(buildBookingOption);

const buildBookingOption = booking => ({
  label: booking.id,
  value: booking.id,
  object: booking
});

// This is used when setting initial value for this field. Because the booking is taken from the booking set data.
export const buildBookingOptionFromBookingSet = booking =>
  buildBookingOption({
    ...booking,
    period: {
      startDate: booking.startDate,
      endDate: booking.endDate
    }
  });

const BookingSelectField = ({
  fetchBookingOptions,
  clearBookingOption,
  name = 'booking',
  showDropdownWhenEmpty = false,
  placeholder = 'Select booking...'
}: any) => (
  <div className="BookingSelectField">
    <div className="inputWrapper" style={{backgroundImage: `url(${zoomIcon})`}}>
      <Field
        name={name}
        component={AsyncSelectField}
        placeholder={placeholder}
        fetchFunction={fetchBookingOptions}
        buildOptions={buildBookingOptions}
        onClear={clearBookingOption}
        optionRenderer={BookingOption}
        valueRenderer={BookingOption}
        arrowRenderer={Arrow}
        filterOptions={false}
        showDropdownWhenEmpty={showDropdownWhenEmpty}
      />
    </div>
  </div>
);

export default BookingSelectField;
